import { ReactElement } from 'react';
import { Task } from '@/api';
import styles from './task-events-panel.module.scss';
import { useTasksTranslation } from '../hooks';
import { TaskDataSectionHeader } from './task-data-section-header';
import { TaskEventsList } from './task-events-list';

type TaskEventsPanelProps = {
    task: Task;
};

/**
 * The task's event history, under its own heading. Lives here rather than on
 * the page because the heading is task vocabulary — `MiniTaskDetail` names the
 * same panel from the same key.
 */
export function TaskEventsPanel(props: TaskEventsPanelProps): ReactElement {
    const { task } = props;
    const { t } = useTasksTranslation();

    return (
        <div className={styles.container}>
            <TaskDataSectionHeader title={t('shared.tasks.section_events')} />
            <TaskEventsList task={task} />
        </div>
    );
}
